<template>
    <b-form-row>
        <b-modal size="xl" button-size="sm" ref="finder" hide-footer :id="this.id" :title="prefix + title">
            <Almoxarifado-List :departamento="departamento" :produto="produto" @onDblClickAlmoxarifado="rowSelect"
                :title="prefix + title + '>'" />
        </b-modal>

        <lg-form-input-finder :value="computedValue" fieldDescription="descricao" :label="label"
            invalidFeedback="Almoxarifado deve ser informado!" description="" @handleClean="handleClean"
            :showClear="!disabled && podeApagar" :disabled="disabled">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed v-if="user !== null" :disabled="disabled">
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"

export default {
    components: { LgFormInputFinder, AlmoxarifadoList: () => import("@/modules/almoxarifados/almoxarifado/AlmoxarifadoList.vue") },

    props: {
        id: {
            type: String,
            default: 'finderAlmoxarifado'
        },
        produto: Object,
        departamento: Object,
        onselect: Function,
        user: Object,
        value: Object,
        prefix: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "Almoxarifado:",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        podeApagar: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            showModal: this.isModal ? true : false,

            internalValue: this.value || {},

            descricao: "",
            title: "Almoxarifado",
        }
    },
    watch: {
        value(newValue) {
            this.internalValue = newValue;
        },
    },

    computed: {
        computedValue: {
            get() {
                return this.internalValue;
            },
            set(newValue) {
                this.internalValue = newValue;
            },
        },
    },

    methods: {
        show() {
            this.$bvModal.show(this.id);
        },
        updateValue(newValue) {
            this.computedValue = newValue;
            this.$emit("input", newValue);
        },
        handleClean() {
            this.computedValue = {};
            this.$emit("input", {});
            this.$bvModal.hide(this.id);

        },
        rowSelect(item) {
            this.computedValue = item;
            this.$emit("onselect", item);
            this.$bvModal.hide(this.id);
        },

    },
}
</script>
